var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStripeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1481,
    height: 1481,
    viewBox: "0 0 1481 1481",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1480.05,
    height: 1480.05,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2890_482)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2365.01 504.59L2355.81 460.926H2228.05V978.68H2375.66V627.299C2410.59 581.626 2469.51 590.517 2488.26 596.333V460.987C2468.59 453.923 2399.57 440.952 2365.01 504.529V504.59ZM2068.74 332.675L1924.53 363.307L1923.92 837.153C1923.92 924.542 1989.63 989.185 2077.33 989.185C2125.59 989.185 2161.24 979.989 2181 969.606V849.333C2162.06 856.884 2068.86 883.984 2068.86 796.961V586.863H2181V460.896H2068.86L2068.74 332.675ZM1668.82 611.161C1668.82 588.081 1688.01 579.19 1719 579.19C1770.31 580.301 1820.66 593.331 1866.07 617.251V478.1C1819.25 459.69 1769.31 450.508 1719 451.061C1599.52 451.061 1519.35 513.664 1519.35 618.165C1519.35 781.675 1743.91 755.124 1743.91 825.613C1743.91 853.2 1720.16 861.726 1687.18 861.726C1638.28 861.726 1575.13 841.508 1525.59 814.53V955.508C1576.59 977.691 1631.57 989.263 1687.18 989.52C1809.98 989.52 1894.63 928.866 1894.63 822.507C1894.63 646.025 1668.79 677.571 1668.79 611.101L1668.82 611.161ZM681.668 536.409C681.668 494.694 716.38 478.556 772.467 478.556C865.293 480.562 956.381 504.131 1038.53 547.401V295.589C953.822 262.299 863.475 245.704 772.467 246.718C556.279 246.718 411.281 359.958 411.281 549.046C411.281 844.887 817.531 796.839 817.531 924.359C817.531 974.235 774.903 989.703 714.918 989.703C626.464 989.703 512.22 953.103 422.608 904.385V1159.49C514.869 1199.63 614.334 1220.58 714.949 1221.05C937.134 1221.05 1090.29 1111.29 1090.29 918.909C1090.29 599.621 681.668 656.652 681.668 536.47V536.409Z",
    fill: "#635BFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2890_482"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 974.366,
    height: 974.366,
    fill: "white",
    transform: "translate(259.031 246.67)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripeLogo);
export default __webpack_public_path__ + "static/media/stripe-logo.a79befbb0b75557743b03fc4df8fc544.svg";
export { ForwardRef as ReactComponent };